export const colors = {
    primary: "#9069c0",
    secondary: "#23232d",
    background: {
        100: "#fafaf5",
        200: "#e1d7cd"
    },
    beige: {
        subtle: "#f6f3f0"
    },
    success: "#b9e19b",
    info: "#9bd7ff",
    infoSubtle: "#e1f3ff",
    highlight: "#d7afe1",
    warning: "#ffcda5",
    danger: "#ff385c",
    inputTextError: "#b30021",
    white: "#ffffff",
    gray: {
        100: "#f9f9f9",
        200: "#ededee",
        300: "#e5e5e6",
        400: "#dcdcdd",
        500: "#d3d3d5",
        600: "#a7a7ab",
        700: "#7b7b81",
        800: "#4f4f57"
    },
    green: {
        subtle: "#eaf6e1"
    }
};
export const colors = {
    primary: "#9069c0",
    secondary: "#23232d",
    background: {
        100: "#fafaf5",
        200: "#e1d7cd"
    },
    beige: {
        subtle: "#f6f3f0"
    },
    success: "#b9e19b",
    info: "#9bd7ff",
    infoSubtle: "#e1f3ff",
    highlight: "#d7afe1",
    warning: "#ffcda5",
    danger: "#ff385c",
    inputTextError: "#b30021",
    white: "#ffffff",
    gray: {
        100: "#f9f9f9",
        200: "#ededee",
        300: "#e5e5e6",
        400: "#dcdcdd",
        500: "#d3d3d5",
        600: "#a7a7ab",
        700: "#7b7b81",
        800: "#4f4f57"
    },
    green: {
        subtle: "#eaf6e1"
    }
};
